// extracted by mini-css-extract-plugin
module.exports = {"popper":"_25d45facb5--popper--R7fLJ"};